import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["exportCanvas", "downloadAllButton"]

    connect() {
        this.templateConfigs = this.readTemplateConfigs()
    }

    readTemplateConfigs() {
        const templates = {}
        this.element.querySelectorAll("[data-social-media-kit-template]").forEach((tpl) => {
            const key = tpl.dataset.socialMediaKitTemplate
            templates[key] = {
                key: key,
                filename: tpl.dataset.filename || key
            }
        })
        return templates
    }

    async downloadSingle(event) {
        const key = event.currentTarget.dataset.templateKey
        await this.renderTemplate(key)
        await this.downloadRenderedTemplate(key)
    }

    async downloadAll() {
        if (typeof JSZip === "undefined") {
            alert("JSZip is not loaded.")
            return
        }

        const originalText = this.downloadAllButtonTarget.innerHTML
        this.downloadAllButtonTarget.disabled = true
        this.downloadAllButtonTarget.classList.add("opacity-70", "cursor-not-allowed")

        try {
            const zip = new JSZip()

            for (const key of Object.keys(this.templateConfigs)) {
                await this.renderTemplate(key)
                const blob = await this.captureBlob()
                zip.file(`${this.templateConfigs[key].filename}.png`, blob)
            }

            const content = await zip.generateAsync({ type: "blob" })
            const link = document.createElement("a")
            link.href = URL.createObjectURL(content)
            link.download = `echoage-social-media-kit-${new Date().toISOString().slice(0, 10)}.zip`
            link.click()
        } catch (error) {
            console.error("Batch download failed:", error)
            alert("Could not generate the social media kit. Please try again.")
        } finally {
            this.downloadAllButtonTarget.disabled = false
            this.downloadAllButtonTarget.classList.remove("opacity-70", "cursor-not-allowed")
            this.downloadAllButtonTarget.innerHTML = originalText
        }
    }

    async renderTemplate(key) {
        const sourceTemplate = this.element.querySelector(`[data-social-media-kit-template="${key}"]`)
        if (!sourceTemplate) return

        this.exportCanvasTarget.style.width = "1080px"
        this.exportCanvasTarget.style.height = "1350px"

        this.exportCanvasTarget.innerHTML = ""
        this.exportCanvasTarget.appendChild(sourceTemplate.content.cloneNode(true))

        await document.fonts.ready
        await this.waitForImages()
        await new Promise(resolve => setTimeout(resolve, 50))
    }

    async waitForImages() {
        const images = Array.from(this.exportCanvasTarget.querySelectorAll("img"))

        await Promise.all(
            images.map((img) => {
                if (img.complete && img.naturalWidth > 0) return Promise.resolve()

                return new Promise((resolve) => {
                    const done = () => resolve()
                    img.addEventListener("load", done, { once: true })
                    img.addEventListener("error", done, { once: true })
                })
            })
        )
    }

    async downloadRenderedTemplate(key) {
        const blob = await this.captureBlob()

        if (!blob || blob.size === 0) {
            throw new Error("Generated file is empty")
        }

        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = `${this.templateConfigs[key].filename}.png`
        link.click()
    }

    async captureBlob() {
        const dataUrl = await htmlToImage.toPng(this.exportCanvasTarget, {
            quality: 1,
            pixelRatio: 2,
            cacheBust: true,
            backgroundColor: "#ffffff"
        })

        const response = await fetch(dataUrl)
        return await response.blob()
    }
}